import img16a from '../../../assets/gallery/16b/16b-01-HOME_SG-2016-125x95cm-oleo-sobre-papel.jpg';
import img16b from '../../../assets/gallery/16b/16b-02_ST-2016-125x95cm-oleo-sobre-papel.jpg';
import img16c from '../../../assets/gallery/16b/16b-03_Ncrekonchoe-1-2016-128x95cm-oleo-y-aceite-de-lino-sobre-papel.jpg';
import img16d from '../../../assets/gallery/16b/16b-04_Ncrekonchoe-4-2016-128x95cm-oleo-y-aceite-de-lino-sobre-papel.jpg';


export const dataImages = [
  {
    id: 1,
    title: "125 x 95 cm",
    dimensions: "",
    pictureSrc: img16a,
    description: "2016",
    orientation: "v"
  },
  {
    id: 2,
    title: "",
    dimensions: "125 x 95 cm",
    pictureSrc: img16b,
    description: "2016",
    orientation: "v"
  },
  {
    id: 3,
    title: "",
    dimensions: "128 x 95 cm",
    pictureSrc: img16c,
    description: "2016",
    orientation: "v"
  },
  {
    id: 4,
    title: "",
    dimensions: "128 x 95 cm",
    pictureSrc: img16d,
    description: "2016",
    orientation: "v"
  },
].sort(() => Math.random() - 0.5);

export const dimensionsH = [
  { width: "820" },
  { width: "730" },
  { width: "700" },
  { width: "650" },
  { width: "539" },
  { width: "444" },
  { width: "400" },
  { width: "382" },
];


export const dimensionsV = [
  { width: "820" },
  { width: "730" },
  { width: "700" },
  { width: "650" },
  { width: "539" },
  { width: "444" },
  { width: "400" },
  { width: "382" },
];


// WEBPACK FOOTER //
// ./src/pages/gallery/16b/data16b.js